import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import RadioButton from 'dpl/components/RadioButton';
import ClickableDiv from 'dpl/common/components/ClickableDiv';
import Icon from 'dpl/common/components/Icon';

export default function SelectPaymentTypeRadio({
  title,
  icon,
  name,
  fee,
  onSelect,
  isSelected,
  listItems,
  onChangeModalClick
}) {
  return (
    <ClickableDiv onClick={onSelect}>
      <div
        className={classnames('SelectPaymentTypeRadio ba br3 pv4 ph6 tl', {
          'b--lightest-gray': !isSelected
        })}
      >
        <div className="flex justify-between">
          <div className="flex align-items-center">
            <Icon
              name={icon}
              height="28px"
              width="28px"
              className="ba br-100 bg-stroll-light b--transparent ph1 pv1"
            />
            <h5 className="f3 ml2">{title}</h5>
            {fee && <span className="f1 mid-gray ml2">{fee}</span>}
          </div>
          <RadioButton
            id={name}
            name={name}
            value={title}
            isChecked={isSelected}
            onClick={() => {}}
          />
        </div>
        <div className="row">
          <div className="mb2">
            <ul className="nv1 nv2-sm ml4 col-11 f2">
              {listItems.map((item, idx) => (
                <li key={idx} className="list--disc-outside mv1 mv2-sm">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          {onChangeModalClick && (
            <div className="w-100 bt b--lightest-gray">
              <button
                type="button"
                className="col-11 f2 fw-medium midnight mt4"
                onClick={() => onChangeModalClick('learnMore', true)}
              >
                Learn more
              </button>
            </div>
          )}
        </div>
        <div />
      </div>
    </ClickableDiv>
  );
}

SelectPaymentTypeRadio.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fee: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  listItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeModalClick: PropTypes.func
};

SelectPaymentTypeRadio.defaultProps = {
  onChangeModalClick: null,
  fee: null
};
